import React from 'react';
import TermsAcceptanceScreen from '../../src/screens/auth/TermsAcceptanceScreen';

export default function TermsAcceptanceRoute() {
  return <TermsAcceptanceScreen />;
}
